import React, { FunctionComponent, useEffect, useState } from "react";
import bgCardDetailBlue from "../../images/bgCardDetailBlue.svg";
import bgCardDetailRed from "../../images/bgCardDetailRed.svg";
import bgCardDetailGreen from "../../images/bgCardDetailGreen.svg";
import Limousin from "../../images/limousin.png";
import Minicoach from "../../images/minicoach.png";
import Mpv from "../../images/prem_mpv.png";
import wheelChair from "../../images/wheelchairnew.png";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";
import axios from "axios";
import { ApiUrl } from "../../utils/ApiUrl";
import { Grow } from "@mui/material";

type cardProps = {
  carId: number;
  button: boolean;
  isMainPage?: boolean;
};

const CardCarDetail: FunctionComponent<cardProps> = ({
  carId,
  button,
  isMainPage,
}) => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [seat, setSeat] = useState(0);
  const [status, setStatus] = useState("");
  const [isFetching, setIsFetching] = useState(true);

  const bgCard =
    carId === 1
      ? bgCardDetailRed
      : carId === 2
      ? bgCardDetailBlue
      : carId === 3
      ? bgCardDetailRed
      : bgCardDetailGreen;

  /**
   * GetData() is a function that uses axios to make a GET request to the API, and then sets the state
   * of the component to the data that is returned
   */
  const GetData = () => {
    axios
      .request({
        method: "GET",
        url: `${ApiUrl}/vehicleTypes/${carId}`,
      })
      .then((res) => {
        setTitle(res.data.name);
        setPrice((res.data.price / 100).toFixed(2));
        setSeat(res.data.seaters);
        setStatus(res.data.status);
        setTimeout(
          function () {
            setIsFetching(false);
          }.bind(this),
          100
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    GetData();
  }, []);

  const btnCardColor =
    carId === 1
      ? "CardButton red"
      : carId === 2
      ? "CardButton blue"
      : carId === 3
      ? "CardButton red"
      : "CardButton green";

  const carPict =
    carId === 1
      ? Minicoach
      : carId === 2
      ? Mpv
      : carId === 3
      ? wheelChair
      : Limousin;

  return (
    <>
      {isFetching ? (
        <div
          className={`w-[220px] h-[261px] ${
            isMainPage && "md:w-[250px] md:h-[250px]"
          } animate-pulse bg-gray-200 rounded-lg transition-opacity my-5`}
        ></div>
      ) : status === "ready" || !isMainPage ? (
        <Grow in={true}>
          <div className="noSelect flex flex-col items-center transition-opacity my-5">
            <img
              src={bgCard}
              className={`noSelect z-0 ${
                isMainPage && "md:w-[250px] md:h-[300px]"
              } w-[220px]`}
              style={{ marginTop: "40px" }}
              alt="bgCard"
            ></img>
            <div
              className={`flex absolute flex-col items-center space-y-3 ${
                isMainPage && "md:space-y-6"
              } justify-between`}
            >
              <img
                src={carPict}
                className={`noSelect h-20 ${isMainPage && "md:h-[105px]"}`}
                alt="carPict"
              ></img>
              <div className="flex flex-col items-center space-y-1">
                <h1
                  className={`text-white font-bold text-xl text-center h-[50px] max-w-[200px] ${
                    isMainPage &&
                    "md:text-[27px] text-center h-[50px] max-w-[200px]"
                  } `}
                >
                  {title}
                </h1>
                <a
                  className={`text-white text-lg ${
                    isMainPage && "md:text-[20px]"
                  } `}
                >
                  ({seat} Seater)
                </a>
                <div className="flex flex-col items-center">
                  <a
                    className={`text-white text-lg ${
                      isMainPage && "md:text-[20px]"
                    } `}
                    style={{ fontWeight: "bold" }}
                  >
                    S${price} Per Trip
                  </a>
                  <a
                    className={`text-white text-base ${
                      isMainPage && "md:text-[16px]"
                    } `}
                  >
                    Inclusive of GST
                  </a>
                </div>
              </div>
              {button ? (
                <Button
                  id={`carId-${carId}`}
                  component={Link}
                  to={`FormBooking/${carId}/fromairport`}
                  onClick={() => {
                    localStorage.clear();
                  }}
                  variant="contained"
                  className={btnCardColor}
                >
                  BOOK NOW
                </Button>
              ) : null}
            </div>
          </div>
        </Grow>
      ) : null}
    </>
  );
};

export default CardCarDetail;
